import { CO2 } from 'src/presentations/components/atom/unit';
import IconCloud from 'src/assets/images/icons/analytic-cloud.svg';
import IconWeight from 'src/assets/images/icons/analytic-weight.svg';
import IconWeightBlue from 'src/assets/images/icons/analytic-weight-blue.svg';
import IconTruck from 'src/assets/images/icons/analytic-truck.svg';
import IconReceipt from 'src/assets/images/icons/new-receipt-text.svg';
import IconBox from 'src/assets/images/icons/analytic-box.svg';
import IconChargesLines from 'src/assets/images/icons/analytic-charges-lines.svg';
import { createMetricsSelector, MetricOption } from '../../../molecules/MetricsSelector';
import IconWarning from 'src/assets/images/icons/analytic-warning-error.svg';
import { CardId } from './types';

const AVAILABLE_METRICS: MetricOption<CardId>[] = [
  { id: CardId.NO_INVOICES, label: 'Invoices', labelText: 'Invoices', icon: IconReceipt },
  { id: CardId.NO_SHIPMENTS, label: 'Shipments', labelText: 'Shipments', icon: IconTruck },
  { id: CardId.NO_CHARGES, label: 'Charges', labelText: 'Charges', icon: IconChargesLines },
  {
    id: CardId.TOTAL_CO2_EMISSIONS,
    label: (
      <>
        <CO2 /> Emissions
      </>
    ),
    labelText: 'CO2e Emissions',
    icon: IconCloud,
  },
  { id: CardId.TOTAL_DEVIATION_AMOUNT, label: 'Total Net Deviation Amount', labelText: 'Deviation', icon: IconWarning },
  { id: CardId.VOLUME, label: 'Volume', labelText: 'Volume', icon: IconBox },
  { id: CardId.CHARGABLE_WEIGHT, label: 'Charg. Weight', labelText: 'Charg. Weight', icon: IconWeight },
  { id: CardId.GROSS_WEIGHT, label: 'Gross Weight', labelText: 'Gross Weight', icon: IconWeightBlue },
];

const DEFAULT_METRICS = [CardId.NO_INVOICES, CardId.NO_SHIPMENTS, CardId.NO_CHARGES, CardId.TOTAL_CO2_EMISSIONS];

export const MetricsSelector = createMetricsSelector({
  metrics: AVAILABLE_METRICS,
  defaultMetrics: DEFAULT_METRICS,
  iconClassName: 'w-20 h-20 ml-4',
});
